module.exports = __webpack_public_path__ + "img/2.718129d3.png";